import { Button, ButtonBase, CircularProgress, Stack, Typography } from '@mui/material';
import { WarningAmber } from '@mui/icons-material';
import { useInventoryForecastGradeNoneCount } from '../hooks/useInventoryForecastGradeNoneCount';
import { useProductsFilter } from '@features/products/hooks/useProductsFilter';
import { Icon, IconSize } from '@shared/icons';

const InventoryForecastGradeNoneIndicator = () => {
  const { count, isLoading } = useInventoryForecastGradeNoneCount();

  const { updateFilter } = useProductsFilter();

  const handleClick = () => {
    updateFilter({
      forecastGrades: ['NONE'],
    });
  };

  if (isLoading) return null;

  if( count === 0 ) return null;

  return (
    <Button variant="text" color="info" onClick={handleClick} sx={{ ml: 1 }} startIcon={<Icon size={IconSize.LARGE} color="secondary" icon="AlertTriangle" />}>
      {count ?? 0} products without forecasts
    </Button>
  );
};

export default InventoryForecastGradeNoneIndicator;
